import MobileModal from './MobileModal';

export default MobileModal;
